import { render, staticRenderFns } from "./CustomProductAddToCart.vue?vue&type=template&id=63573e52&scoped=true&name=the-cart-section&"
import script from "./CustomProductAddToCart.vue?vue&type=script&lang=js&"
export * from "./CustomProductAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductAddToCart.vue?vue&type=style&index=0&id=63573e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63573e52",
  null
  
)

/* custom blocks */
import block0 from "./CustomProductAddToCart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports